import { useState, useEffect, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { axiosInstance } from 'utils/axios';

const useFetchData = (endpoint) => {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const token = useSelector(selectCurrentToken);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get(endpoint, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setData(res.data);
            } else {
                setError('Something went wrong.');
            }
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    }, [endpoint, token]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return { data, error, loading };
};

export default useFetchData;
